<template>
  <div class="container page">
    <div class="header">
      <van-nav-bar :title="$t('my.online_service')" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()"/>
        </template>
      </van-nav-bar>
    </div>
    <div class="ifrmae_page">
      <iframe width="100%" height="100%" frameborder="0" id="iframe_web" :src="serviceUrl"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serviceUrl: 'https://hao.360.com/'
    };
  },
  methods: {
    back(){
      return window.history.back();
    }
  },
  created() {
    const queryUrl = this.$route.query.url;
    const storeUrl = this.$store.getters.getBaseInfo.kefu;
    if (queryUrl) {
      this.serviceUrl = decodeURIComponent(queryUrl);
      return;
    }
    if (storeUrl) {
      this.serviceUrl = storeUrl;
    }
  },
  mounted(){
    /**
     * iframe-宽高自适应显示
     */
    const oIframe = document.getElementById('iframe_web');
    const deviceHeight = document.documentElement.clientHeight;
    oIframe.style.height = (Number(deviceHeight)-65) + 'px'; //数字是页面布局高度差
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
</style>
